import { createTariffHash, getDistinctScheduleTimes, hasSchedulingRequiringSeatSelection } from '@src/common/seatMaps';
import {
  hourSeatMapValidationResultsSelector,
  hourSeatMapValidationStatusSelector,
  hourSeatMapValidationTariffHashSelector,
  tariffsState,
} from '@src/stores/product';
import { getSelectedTariffsPerType } from '@src/domains/tariffs';
import { buildHoursList } from '@src/domains/products/scheduleHours';
import { HourListItem } from '../../productAdder/types/productAdder';
import { useWidgetId } from '@src/core/IdProvider';
import { useAppSelector } from '@src/core/hooks';
import { useMemo } from 'react';

export const useBuildHourList = (): HourListItem[] => {
  const widgetId = useWidgetId();

  const tariffsInformation = useAppSelector(tariffsState(widgetId));
  const { listOfTariffsPerType } = tariffsInformation;

  const selectedTariffsPerType = getSelectedTariffsPerType(listOfTariffsPerType);
  const selectedTariffsHash = createTariffHash(listOfTariffsPerType);
  const hasSchedulingRequiringSeat = hasSchedulingRequiringSeatSelection(listOfTariffsPerType);
  const validationStatus = useAppSelector(hourSeatMapValidationStatusSelector(widgetId));
  const validationResults = useAppSelector(hourSeatMapValidationResultsSelector(widgetId));
  const validationTariffHash = useAppSelector(hourSeatMapValidationTariffHashSelector(widgetId));
  const scheduleTimes = getDistinctScheduleTimes(selectedTariffsPerType);

  const hoursList = useMemo(
    () =>
      buildHoursList({
        scheduleTimes,
        tariffsInformation,
        hasSchedulingRequiringSeat,
        validationStatus,
        validationTariffHash,
        selectedTariffsHash,
        selectedTariffsPerType,
        validationResults,
      }),
    [
      scheduleTimes,
      tariffsInformation,
      hasSchedulingRequiringSeat,
      validationStatus,
      validationTariffHash,
      selectedTariffsHash,
      selectedTariffsPerType,
      validationResults,
    ],
  );

  return hoursList;
};
